angular.module('jv.candidate.details.evaluations.submit.controller', [])
    .controller('CandEvaluationSubmit',['$scope', '$routeParams', 'candidates', '$location', '$rootScope', '$timeout', '$log', 'evalSvc',
        function($scope, $routeParams, candidates, $location, $rootScope, $timeout, $log, evalSvc){
            var xml2json = new X2JS(); // eslint-disable-line no-undef
            var headerData = [];
            var itemData = [];
            var avgData = [];
            var nodeData = [];
            $scope.validEvaluation=true;
            var fastRead = false;

            if(!$rootScope.miniHeader || !$rootScope.miniHeader.show){
                $rootScope.miniHeader = {
                    show: true,
                    back: 'workflow/'+$routeParams.applicationId
                };
            }

            /*
            * Check to show raitngs in eval
            */
            var checkRatingToShow = function(evalDetail){
                if(evalDetail){
                    evalDetail.showRating = false;
                    if(evalDetail && evalDetail.interview && evalDetail.interview.item_asArray){
                        angular.forEach(evalDetail.interview.item_asArray, function(item){
                            if(item._hasrating === 'True'){
                                evalDetail.showRating = true;
                            }
                        });
                    }
                }
            };

            $scope.checkLoggedInUser = function(){
                var list = {};
                var interviewList ;
                $scope.userInterviewList = [];
                angular.forEach($rootScope.workSteps, function(value,key){
                    if(value.model){
                        if(value.model.clone_interviews){
                            list[key] = [];
                            list[key] = value.model.clone_interviews;
                        }
                    }
                });
                angular.forEach(list, function(item){
                    interviewList = item;
                });
                angular.forEach(interviewList, function(value){
                    if(value.user.EId === window._jvselfUser.eid && !value.completed){
                        $scope.userInterviewList.push(value.EId);
                    }
                });
            };

            $scope.checkLoggedInUser();

            var interviewer;
            if($scope.userInterviewList[0]){
                interviewer = $scope.userInterviewList[0];
            }else if($routeParams.interviewId){
                interviewer = $routeParams.interviewId;
            }

            if($rootScope.evaluations && $rootScope.evaluations.justSubmitted){
                fastRead = true;
                $rootScope.evaluations.justSubmitted = false;
            }
            if(!fastRead){
                if($rootScope.fastReadOn) {
                    fastRead = true;
                }
            }
            candidates.getEvaluationForSubmit($routeParams.applicationId, $routeParams.stateId, interviewer , fastRead, function(response){
                if(response.evaluationInfo
                        && JSON.stringify(response.evaluationInfo) !== '{}'
                        && response.evaluationInfo.model
                        && JSON.stringify(response.evaluationInfo.model) !== '{}'){
                    if(response.evaluationInfo.model.interviews && response.evaluationInfo.model.interviews.completed && $location.$$path.indexOf('evaluations-edit') < 0){
                        $location.path('evaluations/' + $routeParams.applicationId + '/list/' + $routeParams.stateId);
                    }

                    $scope.evaluation = response.evaluationInfo.model.interviews || {};
                    $scope.evaluation.elementInfo = response.evaluationInfo.workflowElementInfo;
                    if($scope.evaluation.evaluation){
                        $scope.evaluation.evaluation = $scope.evaluation.evaluation.replace(new RegExp('<\\$\\$hashKey>[0-9A-z]+</\\$\\$hashKey>','g'),'');
                        $scope.evaluation.evaluation = $scope.evaluation.evaluation.replace(new RegExp("'s",'g'),'&apos;s');
                        $scope.evaluation.evaluation = $scope.evaluation.evaluation.replace(new RegExp("n't",'g'),'n&apos;t');
                        $scope.evaluation.evaluation = $scope.evaluation.evaluation.replace(new RegExp('<error>[0-9A-z]+</error>','g'),'');

                        var split = $scope.evaluation.evaluation.split('&');
                        if(split.length > 1){
                            for(var eva =1; eva <split.length; eva ++){
                                if(split[eva].indexOf(';') === -1 || split[eva].indexOf(';') > 6){
                                    split[eva] = 'amp;'+split[eva];
                                }
                            }
                        }
                        $scope.evaluation.evaluation = split.join('&');
                    }

                    var evalXml = xml2json.parseXmlString($scope.evaluation.evaluation);
                    for(var i=0; i<evalXml.childNodes.length; i++){
                        if(evalXml.childNodes[i] && evalXml.childNodes[i].nodeName === 'evaluation'){
                            for(var j=0; j<evalXml.childNodes[i].childNodes.length; j++){
                                var node = evalXml.childNodes[i].childNodes[j];
                                if(node.nodeName === 'interview'){
                                    for(var k=0; k<node.childNodes.length; k++){
                                        var data = {
                                            index : k,
                                            node : node.childNodes[k]
                                        };
                                        if(node.childNodes[k].nodeName === 'header'){
                                            node.childNodes[k].setAttribute('index', k - headerData.length - avgData.length);
                                            headerData.push(data);
                                        }
                                        else if(node.childNodes[k].nodeName === 'item'){
                                            itemData.push(data);
                                        }
                                        else if(node.childNodes[k].nodeName === 'average'){
                                            avgData.push(data);
                                        }
                                        nodeData.push(data);
                                    }
                                }
                            }
                        }
                    }

                    if(!response.evaluationInfo.model.interviews.user || response.evaluationInfo.model.interviews.user.EId === window.jvUser){
                        $scope.evaluation.notMine = false;
                    }else{
                        $scope.evaluation.notMine = true;
                    }
                    $scope.nodeData = nodeData;
                    $scope.evaluation.details = xml2json.xml2json(evalXml).evaluation;
                    checkRatingToShow($scope.evaluation.details);
                } else {
                    $scope.flags.showEmptyFormText = true;
                }
                $scope.flags.loading = false;
            });

            var formatEvaluation = function(data){
                var hasHeader = false;
                data = angular.copy(data);
                delete data.details.showRating;
                delete data.scheduleUtc;

                if(data.details && data.details.summary && data.details.summary.rating_asArray){
                    data.summary = data.details.summary.rating_asArray[0]._rating;
                }

                if (data.recommendation){
                    data.recommendation = '' + data.recommendation;
                }

                if (data && data.details && data.details.interview && data.details.interview.header){
                    hasHeader = true;
                    if(data.details.interview.header_asArray.length > 1){
                        for(var interview =0; interview<data.details.interview.header.length; interview++){
                            delete data.details.interview.header[interview]._index;
                        }
                    }else if(data.details.interview.header_asArray.length === 1){
                        delete data.details.interview.header._index;
                    }
                }

                if(data.EId || $rootScope.sendInterviewEId){
                    data.eid = data.EId ? data.EId : $rootScope.interviewId;
                    delete data.EId;
                }

                if (data.user) {
                    data.user.eid = data.user.EId;
                    delete data.user.EId;
                }
                delete data.completedByUser;

                data.evaluation = xml2json.json2xml_str({evaluation:data.details || {}});

                if(data.evaluation){
                    data.evaluation = data.evaluation.trim();
                    data.evaluation = data.evaluation.replace(new RegExp('<\\$\\$hashKey>[0-9A-z]+</\\$\\$hashKey>','g'),'');
                    data.evaluation = data.evaluation.replace(new RegExp('<error>[0-9A-z]+</error>','g'),'');
                    data.evaluation = data.evaluation.replace(new RegExp('\n','g'),'&#xD;&#xA;');
                    data.evaluation = evalSvc.cleanMalformedURI(data.evaluation);
                }

                var jsonData = xml2json.xml2json(xml2json.parseXmlString(data.evaluation));
                if(angular.isDefined(jsonData.evaluation.parseerror)){
                    var log = {
                        applicationId : $routeParams.applicationId,
                        evaluationJson : data.details,
                        evaluationXml : data.evaluation

                    };
                    $log.error(log);
                }

                if(hasHeader){
                    var evalXml = xml2json.parseXmlString(data.evaluation);
                    $scope.evalXml = evalXml;
                    var headPos = 0;
                    var avgPos = 0;
                    for(var i=0; i<evalXml.childNodes.length; i++){
                        if(evalXml.childNodes[i] && evalXml.childNodes[i].nodeName === 'evaluation'){
                            for(var j=0; j<evalXml.childNodes[i].childNodes.length; j++){
                                var node = evalXml.childNodes[i].childNodes[j];
                                if(node.nodeName === 'interview'){
                                    var temp = evalXml.childNodes[i].childNodes[j].cloneNode(true);
                                    var nodeLen = node.childNodes.length;
                                    for(var nod=nodeLen-1; nod>=0; nod--){
                                        node.removeChild(node.childNodes[nod]);
                                    }
                                    for(var k=0; k<nodeData.length; k++){
                                        if(nodeData[k].node.nodeName === 'header'){
                                            headerData[headPos].node.removeAttribute('index');
                                            node.appendChild(headerData[headPos].node);
                                            headPos++;
                                        }
                                        else if(nodeData[k].node.nodeName === 'item'){
                                            for(var l=0; l<temp.childNodes.length; l++){
                                                if(temp.childNodes[l].nodeName === 'item'){
                                                    node.appendChild(temp.childNodes[l]);
                                                    break;
                                                }
                                            }
                                        }
                                        else if(nodeData[k].node.nodeName === 'average'){
                                            node.appendChild(avgData[avgPos].node);
                                            avgPos++;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(window.XMLSerializer){
                        data.evaluation = new XMLSerializer().serializeToString(evalXml);
                    }else{
                        data.evaluation = evalXml.xml;
                    }
                }

                if(data.evaluation){
                    data.evaluation = data.evaluation.replace(new RegExp('\n','g'),'&#xD;&#xA;');
                }
                delete data.details;
                delete data.submitted;
                return data;
            };

            $scope.submit = function(data) {
                // Copying in case the save fails and the user decides to do draft instead
                data = angular.copy(data);
                $scope.validateEvaluation(data);
                if($scope.validEvaluation){
                    data.completed = true;
                    $timeout.cancel($scope.autoSave.timerObj);
                    $scope.save(data);
                }
            };

            /*@_called directly by 'Save as Draft'*/
            $scope.save = function(data) {
                var postParams = formatEvaluation(data);
                $scope.flags.loading = true;

                candidates.submitEvaluation($routeParams.applicationId, $routeParams.stateId, $routeParams.interviewId, postParams, function(){
                    $rootScope.evaluations = $scope.evaluations || {};
                    $rootScope.evaluations.fastRead = true;
                    $rootScope.evaluations.justSubmitted = true;
                    if(postParams.completed){
                        $scope.$root.notice = i18n.EVALUATION_SUBMITTED;
                    }else{
                        $scope.$root.notice = i18n.SAVED;
                    }
                    $scope.flags.loading = false;
                    $rootScope.$emit('getEvaluationsCount');
                    $location.path('evaluations/' + $routeParams.applicationId+'/list/'+$routeParams.stateId);
                });
            };

            $scope.validateEvaluationItem =function(evalRatingArray){
                var errorFlag=true;
                angular.forEach(evalRatingArray, function(ratingItem){
                    if(ratingItem.error) {
                        delete ratingItem.error;
                    }
                        
                    if(!(ratingItem._isoptional && ratingItem._isoptional === 'True')){
                        if(ratingItem.choice){
                            if(ratingItem._hasrating === 'True'){
                                if(ratingItem._rating==='') {
                                    ratingItem.error=true;
                                } else {
                                    delete ratingItem.error;
                                }
                            }
                            if(ratingItem._hascomments === 'True'){
                                if(ratingItem._comments==='') {
                                    ratingItem.error=true;
                                } else {
                                    delete ratingItem.error;
                                }
                            }
                        }
                        if(ratingItem._hasrating === 'True'){
                            if(angular.isUndefined(ratingItem._rating) || !ratingItem._rating) {
                                ratingItem.error=true;
                            } else {
                                delete ratingItem.error;
                            }
                        }
                        if(!ratingItem.error &&  ratingItem._hascomments === 'True'){
                            if(angular.isUndefined(ratingItem._comments) || !ratingItem._comments) {
                                ratingItem.error=true;
                            } else {
                                delete ratingItem.error;
                            }
                        }
                        if(!ratingItem._hasrating && !ratingItem._hascomments){
                            if(!ratingItem._rating){
                                ratingItem.error=true;
                            }else{
                                delete ratingItem.error;
                            }
                        }
                    }
                    errorFlag = errorFlag && !ratingItem.error;
                });
                return errorFlag;
            };

            $scope.validEvaluation=true;
            $scope.validateEvaluation = function(){
                $scope.validEvaluation = $scope.evaluation.details && $scope.validateEvaluationItem($scope.evaluation.details.summary.rating_asArray) && $scope.validateEvaluationItem($scope.evaluation.details.interview.item_asArray);
            };

            /*@_canceling timer event if moving away from tab*/
            $scope.$on('$routeChangeStart', function(){
                if($scope.autoSave.timerObj) {
                    $timeout.cancel($scope.autoSave.timerObj);
                }
                $scope.autoSave={};
            });

            $scope.autoSave={
                timeOut:60000,
                start: false,
                loading:false,
                timerObj: null,
                showMsg: false,
                /*@_called after timeout duration if autoSave timer is on*/
                post: function(){
                    if($scope.autoSave.start){
                        var postParams = formatEvaluation($scope.evaluation);

                    /*@setting flags to show auto-save caption*/
                        $scope.autoSave.loading=true;
                        candidates.submitEvaluation($routeParams.applicationId, $routeParams.stateId, $routeParams.interviewId, postParams, function(response){
                            if(response.interview && response.interview.EId){
                                $rootScope.evaluations = $rootScope.evaluations || {};
                                $rootScope.evaluations.justSubmitted = true;
                                $rootScope.evaluations.fastRead = true;
                                $routeParams.interviewId = response.interview.EId;
                                $rootScope.sendInterviewEId=true;
                                $rootScope.interviewId=response.interview.EId;
                                $scope.autoSave.showMsg=true;
                                $scope.autoSave.loading=false;
                                $scope.autoSave.start=false;
                                /*@_recursive timer event call to keep it alive*/
                                $scope.autoSave.timerObj=$timeout($scope.autoSave.post,$scope.autoSave.timeOut);
                            }else{
                                /*@_fail-safe code to avoid duplicate evaluation save*/
                                $scope.autoSave.start=false;
                            }
                        });
                    }else{
                        $scope.autoSave.timerObj=$timeout($scope.autoSave.post,$scope.autoSave.timeOut);
                    }
                }
            };

            $scope.autoSave.timerObj=$timeout($scope.autoSave.post,$scope.autoSave.timeOut);

                /*@_watching for any change in form to start auto save*/
            $scope.$watch('evaluation.details', function(newVal, oldVal){
                if(newVal && oldVal && Array.isArray($location.url().match(/evaluations-submit/))){
                    var autoSaveStop=false;
                        /*@_Select2 is causing this watch to trigger as trying to create ng-Model property in object as ''(empty).. Dont start auto-Save on this*/
                    angular.forEach(oldVal.summary.rating_asArray, function(value){
                        if(angular.isUndefined(value._rating)){
                            autoSaveStop=true;
                        }
                    });
                    $scope.autoSave.start= !autoSaveStop;
                }else{
                    $scope.autoSave.start=false;
                }
            },true);
        }
]);